module.exports = __webpack_public_path__ + "static/media/technologies.a0632c55.svg";